import { create } from "zustand";

/** loading は進行中の操作を示し、自動では消えない。完了時に呼び出し側が dismiss する。 */
export type ToastType = "success" | "error" | "info" | "loading";

export interface Toast {
	id: string;
	type: ToastType;
	message: string;
}

interface ToastState {
	toasts: Toast[];
	show: (input: { type: ToastType; message: string }) => string;
	/** 表示中トーストの文言を差し替える (進行中トーストの進捗更新用)。既に消えていれば何もしない。 */
	update: (id: string, message: string) => void;
	dismiss: (id: string) => void;
}

export const useToastStore = create<ToastState>((set) => ({
	toasts: [],
	show: ({ type, message }) => {
		const id = crypto.randomUUID();
		set((state) => ({ toasts: [...state.toasts, { id, type, message }] }));
		return id;
	},
	update: (id, message) => {
		set((state) => ({
			toasts: state.toasts.map((t) =>
				t.id === id && t.message !== message ? { ...t, message } : t,
			),
		}));
	},
	dismiss: (id) => {
		set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
	},
}));
